import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDirection } from '~/hooks/i18nHooks';

const PepList = () => {
  const [t] = useTranslation('ksaApplication');
  const dir = useDirection();

  return (
    <ol className="DeclarationInputs-PepList" dir={dir}>
      <li>
        {t(
          'A natural person who is or has been entrusted with prominent public functions including:'
        )}
        <ul>
          <li>
            {t('a head of state, head of government, minister or deputy or assistant minister;')}
          </li>
          <li>{t('a senior government official; ')}</li>
          <li>{t('a member of parliament;')}</li>
          <li>{t('a senior politician;')}</li>
          <li>{t('an important political party official;')}</li>
          <li>{t('a senior judicial official;')}</li>
          <li>{t('a member of a court of auditors or the board of a central bank;')}</li>
          <li>
            {t(
              'an ambassador, charge d’affaires or other high-ranking officer in a diplomatic service; '
            )}
          </li>
          <li>{t('a high-ranking officer in an armed force;')}</li>
          <li>
            {t(
              'a senior member of an administrative, management or supervisory body of a state-owned enterprise;'
            )}
          </li>
        </ul>
      </li>
      <li>
        {t('Any of the following family members of the above, including:')}
        <ul dir={dir}>
          <li>{t('a spouse;')}</li>
          <li>{t('a partner considered by national law as equivalent to a spouse;')}</li>
          <li>{t('a child')}</li>
        </ul>
      </li>
    </ol>
  );
};

export default PepList;
